import { EvaChart } from "constants/charts.enums";
import { LassoSelectionStates } from "types/lasso";

import { getBoxPlotList } from "./boxPlot";
import { getCagrList } from "./cagr";
import { getCrossPlotList } from "./crossPlot";
import { getCumTimeList } from "./cumTime";
import { getDeclineRateList } from "./declineRate";
import { getProbitList } from "./probit";
import { getRateCumList } from "./rateCum";
import { getRateDateList } from "./rateDate";
import { getRateTimeList } from "./rateTime";
import { getStackedBarList } from "./stackedBar";
import { getTrendDateList } from "./trendDate";

export const LASSO_MAP = {
  [EvaChart.RateCum]: getRateCumList,
  [EvaChart.RecoveryPVI]: getRateCumList,
  [EvaChart.RecoveryTime]: getRateCumList,
  [EvaChart.CrossPlot]: getCrossPlotList,
  [EvaChart.CumTime]: getCumTimeList,
  [EvaChart.RateTime]: getRateTimeList,
  [EvaChart.RateDate]: getRateDateList,
  [EvaChart.TotalRateDate]: () => [],
  [EvaChart.DeclineRate]: getDeclineRateList,
  [EvaChart.CAGR]: getCagrList,
  [EvaChart.StackedBar]: getStackedBarList,
  [EvaChart.StackedBarHorizontal]: getStackedBarList,
  [EvaChart.BoxPlot]: getBoxPlotList,
  [EvaChart.Probit]: getProbitList,
  [EvaChart.Mosaic]: () => [],
  [EvaChart.Pie]: () => [],
  [EvaChart.TotalRateCum]: () => [],
  [EvaChart.MaterialBalanceTime]: () => [],
  [EvaChart.TrendDate]: getTrendDateList,
  // Injector Total shares Trend Date's per-focus-group line shape, so its lasso brush-select
  // list is delegated to the same implementation.
  [EvaChart.InjectorTotal]: getTrendDateList,

  // midstream charts
  [EvaChart.RateDateMidstream]: getRateDateList,
  [EvaChart.TotalRateDateMidstream]: () => [],
  [EvaChart.CrossPlotMidstream]: getCrossPlotList,
  [EvaChart.WellContribution]: () => [],
  [EvaChart.MosaicMidstream]: () => [],
  [EvaChart.StackedBarMidstream]: getStackedBarList,
  [EvaChart.TrendDateMidstream]: getTrendDateList,
  [EvaChart.BoxPlotMidstream]: getBoxPlotList
};

export function getBrushSelectList({
  params,
  chartType,
  series,
  uwiList = [],
  chartInstance,
  isJitterOn
}: LassoSelectionStates): string[] {
  const list = LASSO_MAP[chartType];
  if (!list) {
    throw new Error(`Unknown chart type: ${chartType} to get brush select list`);
  }
  return list({ params, series, uwiList, chartInstance, isJitterOn });
}
